<template>
  <div class="signup">
    <div class="container">
      <h2 class="title text-center pt-3">{{$t("message.setting_confirm")}}</h2>

      <div class="row mt-5">
        <div class="col-8 mx-auto">
          <div class="row">
            <small>{{$t("message.first_name")}}</small>
            <h4 class="text-blue pt-2 width100">{{ registData.user.first_name }}</h4>
          </div>

          <div class="row mt-3">
            <small>{{$t("message.midle_name")}}</small>
            <h4 class="text-blue pt-2 width100">{{ registData.user.sur_name }}</h4>
          </div>

          <div class="row mt-3">
            <small>{{$t("message.family_name")}}</small>
            <h4 class="text-blue pt-2 width100">{{ registData.user.last_name }}</h4>
          </div>

          <div class="row mt-3">
            <small>{{$t("message.gender")}}</small>
            <h4 class="text-blue pt-2 width100">{{ registData.user.gender }}</h4>
          </div>

          <div class="row mt-3">
            <small>{{$t("message.email")}}</small>
            <h4 class="text-blue pt-2 width100">{{ registData.user.email }}</h4>
          </div>

          <div class="row mt-3">
            <small>{{$t("message.lineId")}}</small>
            <h4 class="text-blue pt-2 width100">{{ registData.user.lineId }}</h4>
          </div>

          <div class="row mt-3">
            <small>{{$t("message.country_id")}}</small>
            <h4 class="text-blue pt-2 width100">{{ registData.user.country_id }}</h4>
          </div>

          <div class="row mt-3">
            <small>{{$t("message.live_at_area")}}</small>
            <h4 class="text-blue pt-2 width100">{{ registData.user.live_area }}</h4>
          </div>

          <div class="row mt-3">
            <small>{{$t("message.prefectures")}}</small>
            <h4 class="text-blue pt-2 width100">{{ registData.user.regist }}</h4>
          </div>

          <div class="row mt-3">
            <small>{{$t("message.phone")}}</small>
            <h4 class="text-blue pt-2 width100">{{ registData.user.phone }}</h4>
          </div>

          <div class="row mt-3">
            <small>{{$t("message.issuing_country")}}</small>
            <h4 class="text-blue pt-2 width100">{{ registData.user.issuing_country }}</h4>
          </div>

          <div class="row mt-3">
            <small>{{$t("message.invitation_code")}}</small>
            <h4 class="text-blue pt-2 width100">{{ registData.invitation_code }}</h4>
          </div>

          <div class="row mt-3">
            <small>{{$t("message.IDtype")}}</small>
            <div v-if='registData.user.id_type == "residence"'>
              <img class="img-c isImage" :src="registData.id_images[0]"/>
              <img class="img-c isImage mt-3" :src="registData.id_images[1]"/>
            </div>
            <div v-else>
              <b-img class="img-c isImage" :src="registData.id_images[0]" />
            </div>
            <h4 class="text-blue pt-2 width100">{{ registData.invitation_code }}</h4>
          </div>
        </div>
      </div>

      <div class="row mt-5 mb-5">
        <div class="col-2 ml-auto ">
          <b-button
            type="button"
            class="mx-1 my-2 btn rounded-circle gray-button-fill"
            style="width:4rem;height:4rem;"
            @click='changeMode("profileInfo")'
          >
            back
          </b-button>
        </div>

        <div class="col-2 mr-auto">
          <b-button
            type="button"
            class="mx-1 my-2 btn rounded-circle blue-button"
            style="width:4rem;height:4rem;"
            @click='changeMode("complite")'
          >
            next
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    registData: {
      type: Object
    }
  },
  data () {
    return {
    }
  },
  methods: {
    changeMode(mode){
      this.$store.commit('user/setCache', this.registData)
      this.$emit('next', {mode: mode});
    },
  }
}
</script>
<style scoped lang="scss">
.text-blue{
  color: #006fd2;
}

.img-c {
  max-width: 100%;
}

.isImage{
  min-height: 350px;
  background-position: center !important;
}
</style>